import {
    UPDATE_EQUITY_DETAILS,
    UPDATE_EQUITY_DETAILS_SUCCESS,
    UPDATE_EQUITY_DETAILS_FAILURE,
    RESET_CREATE_UPDATE_EQUITY,
} from '../actions';

const initialState = {
    updateEquity: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    updateEquityLoading: false,
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const updateEquityReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_EQUITY_DETAILS:
            return {
                ...state,
                updateEquityLoading: true,
            };
        case UPDATE_EQUITY_DETAILS_SUCCESS:
            return {
                ...state,
                updateEquity: {
                    data: action.data,
                    statusCode: '10011',
                },
                updateEquityLoading: false,
            };
        case UPDATE_EQUITY_DETAILS_FAILURE:
            return {
                ...state,
                updateEquity: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
                updateEquityLoading: false,
            };
        case RESET_CREATE_UPDATE_EQUITY:
            return initialState;
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'updateEquityKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    updateEquityReducer
);
